// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Address } from './address';
import { Admin } from './admin';
import { Bank } from './bank';
import { Creditor } from './creditor';
import { DocumentRecipient } from './document-recipient';
import { EmployeeClaim } from './employee-claim';
import { EmployeeDatum } from './employee-datum';
import { EmployeeNumber } from './employee-number';
import { SuperFund } from './super-fund';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Employee extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  employeeId!: number;
  accountName?: string;
  accountNo?: string;
  addressId?: number;
  adminId!: number;
  allowances?: number;
  averageHours?: number;
  bankAddress?: string;
  bankId?: number;
  bankName?: string;
  bsb?: string;
  createdBy!: string;
  createdDate!: Date;
  dateOfBirth?: Date;
  dateOfLastWages?: Date;
  dateOfNotice?: Date;
  employeeType?: number;
  endDate?: Date;
  firstName!: string;
  gender?: string;
  holidayYearStart?: Date;
  hourlyRate?: number;
  isDirector!: boolean;
  isExcluded!: boolean;
  isGeerseligible?: boolean;
  lastName!: string;
  leaveAccrual?: number;
  leaveRate?: number;
  leaveTaken?: number;
  nicodeLookupId?: number;
  nonPriorityDays!: number;
  noticePeriod?: number;
  payrollReference?: string;
  positionTitle?: string;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  salary?: number;
  startDate?: Date;
  superFundAccountNo?: string;
  superFundId?: number;
  superRate?: number;
  taxFlags?: number;
  taxRate?: number;
  terminationDate?: Date;
  tfn?: string;
  title?: string;
  totalDays!: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  wagesPeriodLookupId?: number;
  webFlags?: number;
  address!: Address;
  admin!: Admin;
  bank!: Bank;
  creditors!: Creditor[];
  documentRecipients!: DocumentRecipient[];
  employeeClaims!: EmployeeClaim[];
  employeeDatum!: EmployeeDatum;
  employeeNumbers!: EmployeeNumber[];
  superFund!: SuperFund;
}

